import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { config } from "../../config";

const Img = styled.img`
  height: 50px;
`;

const AppLogo = () => {
  const { i18n } = useTranslation();
  const link =
    i18n.language !== "fr"
      ? "https://www.reservation-responsable.org/"
      : "https://www.reservation-responsable.org/";

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      data-test="logo-RR"
    >
      <Img
        src={config.baseImageUrl + "logo-reservation-responsable.png"}
        alt=""
      />
    </a>
  );
};
export const LogoRR = memo(AppLogo);
